import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { FormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TighteningMethod } from 'src/app/Modules/informate/enums/tightening-method.enum';
import { CalculationResult, ToolOutput } from 'src/app/Modules/informate/models/calculationModels';
import { tighteningDetails } from 'src/app/Modules/management/models/organization/tighteningDetails';
import { ManagementApiService } from 'src/app/services';

@Component({
    selector: 'app-joint-tightening-generic',
    templateUrl: './joint-tightening-generic.component.html',
    styleUrls: ['./joint-tightening-generic.component.scss'],
    standalone: false
})
export class JointTighteningGenericComponent {
    @Input() enable: boolean = true;
    @Input() selectedToolId: string;
    @Input() toolsData: ToolOutput[];
    @Input() tighteningFormGroup: UntypedFormGroup;
    @Input() calculationResult: CalculationResult;
    @Input() selectedTool: ToolOutput;
    @Input() TighteningDetailsData: string;

    tighteningMethod: number;
    torqueUnitOptions: any;
    TensionUnitOptions: any;
    selectedTorqueUnit: string;
    selectedTensionUnit: string;
    resBoltStress: string;
    ToolingValue: boolean = true;
    pumpPressures: number[];
    torques: number[];
    TorquePassValues: any;
    PumpPressurepassValues: any;
    pumpPressureUnit: string;
    torqueUnit: string;
    stateOptions: any[];

    TighteningDetails: tighteningDetails;
    sampleData: string =
        '{"ToolId":"10842009-6e06-47f6-b6f7-9afde666c8b9","tighteningMethod":"Torque","ToolingValueAs":true,"BoltStress":"138.58MPa(20100Psi)","TorqueApplied":{"Unit":"Nm","PassValues":[{"Key":"42%","Value":72},{"Key":"66%","Value":72},{"Key":"100%","Value":144},{"Key":"CheckPass","Value":144}]},"PressureApplied":{"Unit":"Bar","PassValues":[{"Key":"Pass1","Value":344.5},{"Key":"Pass2","Value":413.4},{"Key":"Pass3","Value":689},{"Key":"Pass4","Value":689}]}}';

    constructor(
        private ngbActiveModal: NgbActiveModal,
        private fb: UntypedFormBuilder,
        private mgmtSvc: ManagementApiService,
        private cd: ChangeDetectorRef
    ) { }

    ngOnInit(): void {
        if (this.calculationResult) {
            this.toolsData = this.calculationResult.output.tools;
            this.selectedTool = this.toolsData.find((x) => x.isSelected == true);
            this.selectedToolId = this.selectedTool.id;
        }
        this.torqueUnitOptions = [
            { label: 'Nm', value: 'Nm' },
            { label: 'Lbf.ft', value: 'Lbf.ft' },
        ];
        this.TensionUnitOptions = [
            { label: 'Bar', value: 'Bar' },
            { label: 'PSI', value: 'PSI' },
        ];
        this.stateOptions = [
            { label: 'Torque', value: 'Torque' },
            { label: 'Tension', value: 'Tension' },
        ];

        if (this.TighteningDetailsData) {
            this.TighteningDetails = JSON.parse(this.TighteningDetailsData);
            this.selectedTorqueUnit = this.TighteningDetails.torqueapplied.unit;
            this.selectedTensionUnit = this.TighteningDetails.pressureapplied.unit;
            this.selectedToolId = this.TighteningDetails.toolid;
            this.tighteningMethod = this.TighteningDetails.tighteningmethod == 'Torque' ? 0 : 1;
            this.ToolingValue = this.TighteningDetails.toolingvalueas;
            this.resBoltStress = this.TighteningDetails.boltstress;
            this.TorquePassValues = this.TighteningDetails.torqueapplied.passvalues;
            this.PumpPressurepassValues = this.TighteningDetails.torqueapplied.passvalues;
        } else {
            if (this.calculationResult) {
                this.toolsData = this.calculationResult.output.tools;
                this.selectedTool = this.toolsData.find((x) => x.isSelected == true);
                this.selectedToolId = this.selectedTool.id;
            }
            this.selectedTorqueUnit = 'Nm';
            this.selectedTensionUnit = 'Bar';
            this.tighteningMethod = this.calculationResult.input.others.tighteningMethod;
            this.resBoltStress =
                this.calculationResult?.output?.bolt?.residualBoltStress.metric.stringValue.replace(/,/g, '') +
                '(' +
                this.calculationResult?.output?.bolt?.residualBoltStress.imperial.stringValue.replace(/,/g, '') +
                ')'; //this.measSvc.getUserPreferedValue(this.calculationResult?.output?.bolt?.residualBoltStress, UnitType.DefaultStressUnit);
            this.LoadPassValues();
        }
        this.createForm();
    }
    createForm() {
        this.tighteningFormGroup = this.fb.group({
            ToolId: [this.selectedToolId],
            tighteningMethod: [this.tighteningMethod == 0 ? 'Torque' : 'Tension'],
            ToolingValueAs: [this.ToolingValue],
            BoltStress: [this.resBoltStress],
            TorqueApplied: this.fb.group({
                Unit: [this.selectedTorqueUnit],
                PassValues: this.createPassValuesFormArray(this.TorquePassValues),
            }),
            PressureApplied: this.fb.group({
                Unit: [this.selectedTensionUnit],
                PassValues: this.createPassValuesFormArray(this.PumpPressurepassValues),
            }),
        });
        this.cd.detectChanges();
    }
    createPassValuesFormArray(passValuesArray: { Key: string; Value: string }[]): FormArray {
        const passValuesFormArray = this.fb.array([]);
        if (passValuesArray) {
            passValuesArray.forEach((passValue) => {
                passValuesFormArray.push(
                    this.fb.group({
                        Key: [passValue.Key],
                        Value: [passValue.Value],
                    })
                );
            });
        }

        return passValuesFormArray;
    }

    ButtonValues(passValue: any) {
        return passValue.controls['Key'].value;
    }
    get torquePassValues1() {
        return this.tighteningFormGroup.get('TorqueApplied.PassValues') as FormArray;
    }

    get pressurePassValues1() {
        return this.tighteningFormGroup.get('PressureApplied.PassValues') as FormArray;
    }
    closeClick() {
        this.ngbActiveModal.close();
    }

    loadPumpPressure() {
        this.PumpPressurepassValues = [];
        if (this.calculationResult !== null) {
            if (this.calculationResult?.input?.others?.tighteningMethod == TighteningMethod.Tension) {
                //Pass1
                if (this.selectedTool?.pass1 != undefined && this.selectedTool?.pass1 != null) {
                    this.PumpPressurepassValues.push({
                        Key: 'Pass1',
                        Value: parseFloat(
                            this.selectedTensionUnit.toUpperCase() == 'BAR'
                                ? this.selectedTool.pass1.metric.stringValue.toString().replace(/\s+/g, '').trim()
                                : this.selectedTool.pass1.imperial.stringValue.toString().replace(/\s+/g, '').trim()
                        ),
                    });
                }

                //Pass2
                if (this.selectedTool?.pass2 != undefined && this.selectedTool?.pass2 != null) {
                    this.PumpPressurepassValues.push({
                        Key: 'Pass2',
                        Value: parseFloat(
                            this.selectedTensionUnit.toUpperCase() == 'BAR'
                                ? this.selectedTool.pass2.metric.stringValue.replace(/,/g, '')
                                : this.selectedTool.pass2.imperial.stringValue.replace(/,/g, '')
                        ),
                    });
                }
                //Pass3
                if (this.selectedTool?.pass3 != undefined && this.selectedTool?.pass3 !== null) {
                    this.PumpPressurepassValues.push({
                        Key: 'Pass3',
                        Value: parseFloat(
                            this.selectedTensionUnit.toUpperCase() == 'BAR'
                                ? this.selectedTool.pass3.metric.stringValue.replace(/,/g, '')
                                : this.selectedTool.pass3.imperial.stringValue.replace(/,/g, '')
                        ),
                    });
                }
                //Pass4
                if (this.selectedTool?.pass4 != undefined && this.selectedTool?.pass4 !== null) {
                    this.PumpPressurepassValues.push({
                        Key: 'Pass4',
                        Value: parseFloat(
                            this.selectedTensionUnit.toUpperCase() == 'BAR'
                                ? this.selectedTool.pass4.metric.stringValue.replace(/,/g, '')
                                : this.selectedTool.pass4.imperial.stringValue.replace(/,/g, '')
                        ),
                    });
                }
            } else {
                let isPass1 = this.checkUserprefrences('Calculation_Pass1_Visible');
                let isPass2 = this.checkUserprefrences('Calculation_Pass2_Visible');
                let isPass3 = this.checkUserprefrences('Calculation_Pass3_Visible');
                let isPass4 = this.checkUserprefrences('Calculation_Pass4_Visible');
                if (this.selectedTool?.maximumPressure !== null && isPass1) {
                    let perc =
                        (parseFloat(
                            this.selectedTensionUnit.toUpperCase() == 'BAR'
                                ? this.selectedTool?.maximumPressure.metric.stringValue.replace(/,/g, '')
                                : this.selectedTool?.maximumPressure.imperial.stringValue.replace(/,/g, '')
                        ) *
                            parseFloat(this.mgmtSvc.userDefaults.find((x) => x.userPreferenceKey == 'Calculation_Pass1_Value').userPreference)) /
                        100;
                    this.PumpPressurepassValues.push({ Key: 'Pass1', Value: perc });
                }
                if (this.selectedTool?.maximumPressure !== null && isPass2) {
                    let perc =
                        (parseFloat(
                            this.selectedTensionUnit.toUpperCase() == 'BAR'
                                ? this.selectedTool?.maximumPressure.metric.stringValue.replace(/,/g, '')
                                : this.selectedTool?.maximumPressure.imperial.stringValue.replace(/,/g, '')
                        ) *
                            parseFloat(this.mgmtSvc.userDefaults.find((x) => x.userPreferenceKey == 'Calculation_Pass2_Value').userPreference)) /
                        100;
                    this.PumpPressurepassValues.push({ Key: 'Pass2', Value: perc });
                }
                if (this.selectedTool?.maximumPressure !== null && isPass3) {
                    let perc =
                        (parseFloat(
                            this.selectedTensionUnit.toUpperCase() == 'BAR'
                                ? this.selectedTool?.maximumPressure.metric.stringValue.replace(/,/g, '')
                                : this.selectedTool?.maximumPressure.imperial.stringValue.replace(/,/g, '')
                        ) *
                            parseFloat(this.mgmtSvc.userDefaults.find((x) => x.userPreferenceKey == 'Calculation_Pass3_Value').userPreference)) /
                        100;
                    this.PumpPressurepassValues.push({ Key: 'Pass3', Value: perc });
                }
                if (this.selectedTool?.maximumPressure !== null && isPass4) {
                    let perc =
                        (parseFloat(
                            this.selectedTensionUnit.toUpperCase() == 'BAR'
                                ? this.selectedTool?.maximumPressure.metric.stringValue.replace(/,/g, '')
                                : this.selectedTool?.maximumPressure.imperial.stringValue.replace(/,/g, '')
                        ) *
                            parseFloat(this.mgmtSvc.userDefaults.find((x) => x.userPreferenceKey == 'Calculation_Pass4_Value').userPreference)) /
                        100;
                    this.PumpPressurepassValues.push({ Key: 'Pass4', Value: perc });
                }
            }
        }
    }

    checkUserprefrences(userPrefferd) {
        return this.mgmtSvc.userDefaults.find((item) => item.userPreferenceKey == userPrefferd).userPreference === 'True' ? true : false;
    }

    loadTorque() {
        if (this.calculationResult?.input?.others?.tighteningMethod == TighteningMethod.Torque) {
            this.TorquePassValues = [];
            if (this.selectedTorqueUnit == 'Nm') {
                this.TorquePassValues.push({
                    Key: this.mgmtSvc.userDefaults.find((x) => x.userPreferenceKey == 'Calculation_Pass1_Text').userPreference,
                    Value: parseFloat(
                        this.calculationResult.output.general.torqueLongForm1.metric.stringValue.replace(/,/g, '') ??
                        this.calculationResult.output.general.torqueShortForm1.metric.stringValue.replace(/,/g, '')
                    ),
                });
                this.TorquePassValues.push({
                    Key: this.mgmtSvc.userDefaults.find((x) => x.userPreferenceKey == 'Calculation_Pass2_Text').userPreference,
                    Value: parseFloat(
                        this.calculationResult.output.general.torqueLongForm1.metric.stringValue.replace(/,/g, '') ??
                        this.calculationResult.output.general.torqueShortForm2.metric.stringValue.replace(/,/g, '')
                    ),
                });
                this.TorquePassValues.push({
                    Key: this.mgmtSvc.userDefaults.find((x) => x.userPreferenceKey == 'Calculation_Pass3_Text').userPreference,
                    Value: parseFloat(
                        this.calculationResult.output.general.torqueLongForm3.metric.stringValue.replace(/,/g, '') ??
                        this.calculationResult.output.general.torqueShortForm3.metric.stringValue.replace(/,/g, '')
                    ),
                });
                this.TorquePassValues.push({
                    Key: this.mgmtSvc.userDefaults.find((x) => x.userPreferenceKey == 'Calculation_Pass4_Text').userPreference,
                    Value: parseFloat(
                        this.calculationResult.output.general.torqueLongForm4.metric.stringValue.replace(/,/g, '') ??
                        this.calculationResult.output.general.torqueShortForm4.metric.stringValue.replace(/,/g, '')
                    ),
                });
            } else {
                this.TorquePassValues.push({
                    Key: this.mgmtSvc.userDefaults.find((x) => x.userPreferenceKey == 'Calculation_Pass1_Text').userPreference,
                    Value: parseFloat(
                        this.calculationResult.output.general.torqueLongForm1.imperial.stringValue.replace(/,/g, '') ??
                        this.calculationResult.output.general.torqueShortForm1.imperial.stringValue.replace(/,/g, '')
                    ),
                });
                this.TorquePassValues.push({
                    Key: this.mgmtSvc.userDefaults.find((x) => x.userPreferenceKey == 'Calculation_Pass2_Text').userPreference,
                    Value: parseFloat(
                        this.calculationResult.output.general.torqueLongForm1.imperial.stringValue.replace(/,/g, '') ??
                        this.calculationResult.output.general.torqueShortForm2.imperial.stringValue.replace(/,/g, '')
                    ),
                });
                this.TorquePassValues.push({
                    Key: this.mgmtSvc.userDefaults.find((x) => x.userPreferenceKey == 'Calculation_Pass3_Text').userPreference,
                    Value: parseFloat(
                        this.calculationResult.output.general.torqueLongForm3.imperial.stringValue.replace(/,/g, '') ??
                        this.calculationResult.output.general.torqueShortForm3.imperial.stringValue.replace(/,/g, '')
                    ),
                });
                this.TorquePassValues.push({
                    Key: this.mgmtSvc.userDefaults.find((x) => x.userPreferenceKey == 'Calculation_Pass4_Text').userPreference,
                    Value: parseFloat(
                        this.calculationResult.output.general.torqueLongForm4.imperial.stringValue.replace(/,/g, '') ??
                        this.calculationResult.output.general.torqueShortForm4.imperial.stringValue.replace(/,/g, '')
                    ),
                });
            }
        }
    }

    toolValueChecked(event: any) {
        this.ToolingValue = event.checked;
        this.cd.detectChanges();
    }

    LoadPassValues() {
        if ((this.tighteningMethod == 0 && this.selectedTool.isPowered == true) || this.tighteningMethod == 1) {
            this.loadPumpPressure();
        }
        if (this.tighteningMethod == 0) {
            this.loadTorque();
        }
        this.createForm();
    }

    selectedToolChange(selectedValue: MatSelectChange): void {
        const selection = this.toolsData.find((x) => x.id === selectedValue.value);
        if (selection) {
            this.selectedTool = selection;
            this.selectedToolId = this.selectedTool.id;
            if (!this.TighteningDetails) {
                this.selectedTorqueUnit = 'Nm';
                this.selectedTensionUnit = 'Bar';
            } else {
                this.selectedTorqueUnit = this.TighteningDetails.torqueapplied.unit;
                this.selectedTensionUnit = this.TighteningDetails.pressureapplied.unit;
            }
            this.LoadPassValues();
        }
    }

    torqueUnitChange(selectedValue: MatSelectChange) {
        const selection = this.torqueUnitOptions.find((x) => x.value === selectedValue.value);
        if (selection) {
            this.selectedTorqueUnit = selection.value;
            this.loadTorque();
            this.createForm();
        }
    }

    tensionUnitChange(selectedValue: MatSelectChange) {
        const selection = this.TensionUnitOptions.find((x) => x.value === selectedValue.value);
        if (selection) {
            this.selectedTensionUnit = selection.value;
            this.loadPumpPressure();
            this.createForm();
        }
    }

    Submit() {
    }
}
